import { z } from 'zod';
import { requireFields, yesNo, yesNoRequired } from '@utils/form-schema';

export const pregnancyOrNursingSchema = z
    .object({
        hasBeenPregnant: yesNoRequired,
        isPregnant: yesNo,
        monthsSincePregnant: z.string(),
        hadGestationalDiabetes: yesNo,
        isNursing: yesNo,
        isPlanningOnPregnancy: yesNoRequired,
        isTakingBirthControl: yesNoRequired,
        birthControlForm: z.string(),
        birthControlMonths: z.string(),
        birthControlComplications: z.string(),
        isAbleToStopBirthControl: yesNo,
    })
    .superRefine((data, ctx) => {
        if (data.hasBeenPregnant === '1') {
            requireFields(ctx, data, 'hadGestationalDiabetes', 'isPregnant', 'isNursing');

            if (data.isPregnant === '0') {
                requireFields(ctx, data, 'monthsSincePregnant');
            }
        }

        if (data.isTakingBirthControl === '1') {
            requireFields(
                ctx,
                data,
                'birthControlForm',
                'birthControlMonths',
                'birthControlComplications',
                'isAbleToStopBirthControl',
            );
        }
    });
